import React from 'react'
import { connect } from 'react-redux'
import { setUserInfo, setIsLogin } from '../libs/action'
import { Api } from '../libs/api'
import { getCookie } from 'common/util/cookie'

import { numberFormat, itemImage } from 'common/util/util'

class OrderHead extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            UserInfo: {},
            isLogin: false,
            isBookMarkLayer: false,
        }
        this.domain = window.location.hostname.split('.')[0] // domain
        if (window.isSearch) this.domain = 'search'
    }

    componentDidMount() {
        let authToken = getCookie('auth_token')
        if (authToken) {
            Api.getUserInfo().then(rst => {
                if (rst.data.code === 200) {
                    if (rst.data.isLogin) {
                        this.setState({ isLogin: rst.data.isLogin, userInfo: rst.data.result })
                        this.props.setIsLogin(rst.data.isLogin)
                        this.props.setUserInfo(rst.data.result)
                    }
                }
            })
        }
    }

    getEstimateItem(v, i) {
        return (
            <li key={i}>
                <a href={v.href} target="_blank">
                    <div className="HTTBTCTSILItem">
                        <span className="HTTBTCTSILIThumb">{itemImage(v.thumbnail, v.full_item_name, 200)}</span>
                        <div className="HTTBTCTSILIInfo">
                            <strong className="HTTBTCTSILIICorpname">[{v.cate_name}]</strong>
                            <span className="HTTBTCTSILIIName">{v.full_item_name}</span>
                            {v.price_low === 0 ? (
                                <span className="HTTBTCTSILIIPrice" style={{ color: '#f60' }}>
                                    가격 비교 예정
                                </span>
                            ) : (
                                <span className="HTTBTCTSILIIPrice">{numberFormat(v.price_low)} 원</span>
                            )}
                        </div>
                    </div>
                </a>
            </li>
        )
    }

    getCartItem(v, i) {
        return (
            <li key={i}>
                <a href={v.href} target="_blank">
                    <div className="HTTBTCTSILItem">
                        <span className="HTTBTCTSILIThumb">{itemImage(v.thumbnail, v.full_item_name, 200)}</span>
                        <div className="HTTBTCTSILIInfo">
                            <strong className="HTTBTCTSILIICorpname">{v.mall_name}</strong>
                            <span className="HTTBTCTSILIIName">{v.full_item_name}</span>
                        </div>
                    </div>
                </a>
            </li>
        )
    }

    onBookMark() {
        if (this.state.isBookMarkLayer) {
            this.setState({ isBookMarkLayer: false })
        } else {
            this.setState({ isBookMarkLayer: true })
        }
    }

    bookMarkLayer() {
        return (
            <table id="lyrPop" className="bgdark">
                <tbody>
                    <tr>
                        <td>
                            <div className="PopMain artPop">
                                <strong>
                                    <font className="pfClr1">Ctrl + D</font> 키를 눌러
                                    <br />
                                    즐겨찾기에 등록하실 수 있습니다.
                                </strong>
                                <div className="popDefBtns">
                                    <button className="icon-X_close" onClick={() => this.onBookMark()} />
                                    <button className="confBtn" onClick={() => this.onBookMark()}>
                                        확인
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        )
    }

    image(src, errSrc, title) {
        return <img src={src} onError={e => e.target.src = errSrc} title={title} alt=""/>
    }

    validateLogo(miniShopInfo, mainLogo) {
        let imageSeasonLogo = ''
        let imageDesktopLogo = ''
        let imageFixLogo = ''

        if (Object.keys(miniShopInfo).length === 0) {
            let { seasonLogo, desktopLogo, desktopFixLogo } = mainLogo
            imageSeasonLogo = seasonLogo
            imageDesktopLogo = desktopLogo
            imageFixLogo = desktopFixLogo
        } else {
            let { image_logo_season, image_logo_desktop, image_logo_fix } = miniShopInfo
            imageSeasonLogo = image_logo_season
            imageDesktopLogo = image_logo_desktop
            imageFixLogo = image_logo_fix
        }
        let logoImg = this.image(imageSeasonLogo, imageDesktopLogo)

        return { imageFixLogo, logoImg }
    }

    render() {
        const { fixMode, miniShopInfo, mainLogo } = this.props
        const { imageFixLogo, logoImg } = this.validateLogo(miniShopInfo, mainLogo)
        const mallNum = (miniShopInfo && miniShopInfo.mall_num) && miniShopInfo.mall_num; //mallNum->0 행복쇼핑

        return (
            <div className="HTopArea" style={{ borderBottom: '1px solid #418ded' }}>
                {/* <!-- // HTTop --> */}
                <div className="HTMain ADTWrap">
                    <figure className="HTMCi HTMObj">
                        {fixMode ? (
                            <span>
                                <a href={process.env.REACT_APP_WWW_URL}>
                                    <img
                                        src={`${imageFixLogo}`}
                                        width="36px"
                                        height="36px"
                                        alt="행복쇼핑 CI"
                                    />
                                </a>

                            </span>
                        ) : (window.isMiniShop && mallNum !== 0) ? (
                            <a href={process.env.REACT_APP_MINISHOP_URL + '/' + window.shopID}>{logoImg}</a>
                        ) : (
                            <a href={process.env.REACT_APP_WWW_URL}>{logoImg}</a>
                        )}
                    </figure>
                </div>
            </div>
        )
    }
}

let stateData = state => {
    return {
        userInfo: state.user.userInfo,
        isLogin: state.user.isLogin,
    }
}

let dispatchData = dispatch => {
    return {
        setUserInfo: userInfo => dispatch(setUserInfo(userInfo)),
        setIsLogin: isLogin => dispatch(setIsLogin(isLogin)),
    }
}

export default connect(
    stateData,
    dispatchData,
)(OrderHead)



// WEBPACK FOOTER //
// ./src/header/component/orderhead.js